import { render, staticRenderFns } from "./field.vue?vue&type=template&id=1baccc3c&scoped=true&"
import script from "./field.vue?vue&type=script&lang=js&"
export * from "./field.vue?vue&type=script&lang=js&"
import style0 from "./field.vue?vue&type=style&index=0&id=1baccc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baccc3c",
  null
  
)

export default component.exports